import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { CertificationsPermitsModule } from './certifications-permits/certifications-permits.module';
import { CompletedLoadsForDriverComponent } from './driver-details/completed-loads/completed-loads-for-driver.component';
import { DriverDetailsComponent } from './driver-details/driver-details.component';
import { ProfileComponent } from './driver-details/profile/profile.component';
import { SafetyComponent } from './driver-details/safety/safety.component';
import { ScorecardComponent } from './driver-details/scorecard/scorecard.component';
import { DriversListComponent } from './drivers-list/drivers-list.component';
import { DriversRoutingModule } from './drivers-routing.module';
import { InviteAdminComponent } from './invite-admin/invite-admin.component';
import { InviteDriverComponent } from './invite-driver/invite-driver.component';
import { Invite5fTourDriverComponent } from './invite-tour-driver/invite-tour-driver.component';

@NgModule({
  declarations: [
    DriversListComponent,
    InviteDriverComponent,
    DriverDetailsComponent,
    ScorecardComponent,
    CompletedLoadsForDriverComponent,
    ProfileComponent,
    InviteAdminComponent,
    SafetyComponent,
    Invite5fTourDriverComponent,
  ],
  imports: [
    CommonModule,
    DriversRoutingModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatIntlTelInputModule,
    CertificationsPermitsModule,
    SharedModule,
  ],
})
export class DriversModule {}
